'use client';

import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import P from '@/components/typography/p';
import { Button } from '@/components/ui/button';
import { RichText } from '@/components/ui/rich-text';
import { cn } from '@/lib/utils';
import { Media } from '@/payload-types';
import {
    SerializedEditorState,
    SerializedLexicalNode,
} from '@payloadcms/richtext-lexical/lexical';
import Link from 'next/link';

type TextLeftProps = {
    titel: string | null | undefined;
    tekst: SerializedEditorState<SerializedLexicalNode>;
    bijlage?: {
        bijlageToevoegen?: boolean | null;
        bijlageLabel?: string | null;
        bijlageBestand?: (string | null) | Media;
        bijlageLink?: string | null;
    };
    className?: string;
};

export default function TextLeft({
    titel,
    tekst,
    bijlage,
    className,
}: TextLeftProps) {
    return (
        <div
            className={cn(
                'flex flex-col px-5 lg:mr-auto lg:ml-[10.5rem]',
                className,
            )}
        >
            <H3 className="mb-[1.25rem]">{titel}</H3>
            <P>
                <RichText data={tekst} />
            </P>
            {bijlage?.bijlageToevoegen && bijlage.bijlageBestand ? (
                <div className="border-primary mt-4 flex max-w-[20rem] items-center justify-between gap-2 rounded-lg border px-4 py-3 md:gap-4 lg:mt-10 lg:w-fit lg:max-w-[26rem] lg:gap-8 lg:py-4">
                    <Label variant="default">
                        {bijlage.bijlageLabel || 'Download hier onze bijlage'}
                    </Label>
                    <Link
                        href={bijlage.bijlageBestand as string}
                        download={
                            typeof bijlage.bijlageBestand === 'string'
                                ? bijlage.bijlageBestand
                                : bijlage.bijlageBestand?.filename
                        }
                        target="_blank"
                    >
                        <Button className="lg:px-8">
                            <Label variant="button" className="underline">
                                Download
                            </Label>
                        </Button>
                    </Link>
                </div>
            ) : null}
            {bijlage?.bijlageToevoegen && bijlage.bijlageLink ? (
                <Link
                    href={bijlage.bijlageLink as string}
                    className="w-fit"
                    target="_blank"
                >
                    <Button
                        variant={'ghost'}
                        className="mt-4 mb-[8.5rem] -ml-4 w-fit hover:cursor-pointer"
                    >
                        <Label variant="button" className="underline">
                            Bekijk meer info
                        </Label>
                    </Button>
                </Link>
            ) : null}
        </div>
    );
}
